module.exports = __webpack_public_path__ + "img/生态基地顶部.fc9ebc00.png";